import { render, staticRenderFns } from "./eventStudent.vue?vue&type=template&id=5655774a&scoped=true&"
import script from "./eventStudent.vue?vue&type=script&lang=js&"
export * from "./eventStudent.vue?vue&type=script&lang=js&"
import style0 from "./eventStudent.vue?vue&type=style&index=0&id=5655774a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5655774a",
  null
  
)

export default component.exports